module.exports = (__webpack_public_path__ || '') + "static/images/AppStoreText-0c6cb2df66ecb58d50e2f11c81d785e2.svg";